import {GET_ARTISTS} from "../actionTypes";

export const  Artist = (state=[], action)=>{
	switch (action.type){
		case GET_ARTISTS:
			return action.payload;
		default:
			return  state;
	}
}
